import React from 'react';
import {Link} from "react-router-dom";
import classes from './logo.module.css';

const Logo = () => {
    return (
        <Link to={'/'} className={classes.logo}>
            aquageo.kz
        </Link>
    );
};

export default Logo;